import getAPIDomain from '@purecarslabs/signal-utils/env/apiDomain'
import applyMiddleware from '@purecarslabs/signal-core/baseline/data/middleware/apply-middleware'

const fetchFromAccounts = (path: string) =>
  fetch(`${getAPIDomain('/accounts/info')}/${path}`)

export default applyMiddleware()(fetchFromAccounts)
